export default __webpack_public_path__ + "static/media/12.2ff8b6c4.jpeg";